import React, { Component } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { Box, xcss } from '@atlaskit/primitives';
import type { EcosystemTimeoutViewProps } from '@atlassian/jira-connect-utils/src/common/types.tsx';
import ErrorImageIllustration from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { defineMessages, injectIntl, type IntlShape } from '@atlassian/jira-intl';

const messages = defineMessages({
	timeout: {
		id: 'connect-utils-async.common.ecosystem-timeout-view.timeout',
		defaultMessage:
			"We're having trouble connecting to {appName}.\nTry contacting the developer for support.",
		description:
			"A message displayed to the user inside Timeout component when there's a problem with rendering a Connect app inside" +
			'Issue View or Global Issue Create.',
	},
});

// https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
const getSupportUrl = (appKey: string) =>
	`https://marketplace.atlassian.com/plugins/${appKey}/cloud/support?rel="noopener noreferrer"`;

const imageSize = 80;

type Props = EcosystemTimeoutViewProps & {
	intl: IntlShape;
};

const ErrorImage = () => (
	<Box xcss={imageWrapperStyles}>
		<ErrorImageIllustration fill alt="" />
	</Box>
);

// eslint-disable-next-line jira/react/no-class-components
export class TimeoutView extends Component<Props> {
	static displayName = 'TimeoutView';

	renderImage = getAkEmptyStateRenderImageFn(ErrorImage);

	tertiaryAction = (
		<Button appearance="subtle-link" href={getSupportUrl(this.props.appKey)} target="_blank">
			{this.props.appName}
		</Button>
	);

	render() {
		const { appName, intl } = this.props;
		return (
			<>
				{/* @ts-expect-error - TS2741 - Property 'header' is missing in type '{ size: "narrow"; imageUrl: string; maxImageWidth: number; maxImageHeight: number; isLoading: false; description: string; tertiaryAction: Element; }' but required in type 'EmptyStateProps'. */}
				<EmptyState
					size="narrow"
					renderImage={getAkEmptyStateRenderImageFn(ErrorImage)}
					maxImageWidth={imageSize}
					maxImageHeight={imageSize}
					isLoading={false}
					description={intl.formatMessage(messages.timeout, { appName })}
					tertiaryAction={this.tertiaryAction}
				/>
			</>
		);
	}
}
const imageWrapperStyles = xcss({
	width: '80px',
	height: '80px',
	position: 'relative',
});

export default injectIntl(TimeoutView);
